/**
 * En el demo no hay login: el visitante entra directo al panel.
 * Si por algún motivo aterriza en /login (links viejos, devtools, etc.)
 * lo redirigimos al store demo.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    throw redirect({ to: '/store/$id', params: { id: 'tnt_demo' } })
  },
})
